import { deliveryFields, notesFields } from '../../formFields';
import { observable } from 'mobx';

export class OrderBasketStore {
  private static _instance: OrderBasketStore;

  public static GetInstance() {
    if (this._instance == undefined) {
      this._instance = new OrderBasketStore();
    }

    return this._instance;
  }

  public static ResetInstance() {
    this._instance = new OrderBasketStore();
  }

  @observable
  public deliveryForm = {
    form: 'delivery',
    fields: deliveryFields
  };

  @observable
  public notesForm = {
    form: 'notes',
    fields: notesFields
  };

  @observable
  public shipmentForm = {
    form: 'shipment',
    fields: [
      {
        fieldName: 'Shipment',
        type: 'radioTable',
        label: 'Doprava',
        isRequired: true,
        fields: []
      }
    ]
  };

  @observable
  public paymentForm = {
    form: 'payment',
    fields: [
      {
        fieldName: 'Payment',
        type: 'radioTable',
        label: 'Platba',
        isRequired: true,
        fields: []
      }
    ]
  };

  @observable
  public formsFields = {
    delivery: this.deliveryForm.fields,
    notes: this.notesForm.fields,
    shipment: this.shipmentForm.fields,
    payment: this.paymentForm.fields
  };

  @observable
  public formsValues = {
    delivery: {
      Firstname: '',
      Lastname: '',
      Email: '',
      Phone: '',
      AddressZip: '',
      AddressStreetNumber: '',
      AddressStreet: '',
      AddressCountry: 'cz',
      AddressCity: '',
      Newsletter: '',
      Company: ''
    },
    notes: {
      Notes: ''
    },
    shipment: {} as any,
    payment: {} as any
  };

  private constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/pages/OrderBasket/OrderBasketStore.ts